<script>
  import DatePicker from '../Flatpickr/DatePicker.svelte';
  import { customInputEvent, searchKeyByValue } from 'components/Helper.js';
  import DropDown from '../../components/DropDown.svelte';

  import Select from 'svelte-select';
  import { getContext } from 'svelte';

  export let projectTypes;
  export let sows;
  export let form;
  export let errors;
  export let handleChange;

  let otherSowName;

  let selectProject = null;
  let selectSow = null;

  const showDialog = getContext('showDialog');

  function addProjectType() {
    let selectProjects = projectTypes.filter((item) => item.checked);
    if (selectProjects.length > 0) {
      let arr = $form.projectTypes;
      for (let i in selectProjects) {
        let selectProject = selectProjects[i];
        if (searchKeyByValue(arr, 'unitProjectTypeId', selectProject.id) !== -1) {
          let endDateAdded = true;
          for (var j in arr) {
            if (arr[j].unitProjectTypeId == selectProject.id && arr[j].endDate == '') {
              endDateAdded = false;
            }
          }
          if (endDateAdded == false) {
            return showDialog({
              message: 'To add the same project multiple times, please add end date.',
            });
          }
          // return showDialog({message:"Project already selected"})
        }
      }
      for (let i in selectProjects) {
        let selectProject = selectProjects[i];
        arr.push({
          id: '',
          unitProjectTypeId: selectProject.id,
          name: selectProject.name,
          startDate: '',
          endDate: '',
        });
        $form.projectTypes = arr;
      }
      setTimeout(() => {
        projectTypes = projectTypes.map((item) => {
          item.checked = false;
          return item;
        });
      }, 100);
    } else {
      showDialog({ message: 'Please Select Project' });
    }
  }
  // function addProjectType() {
  //   if(selectProject != null){
  //     let arr = $form.projectTypes;
  //     if(searchKeyByValue(arr,"unitProjectTypeId",selectProject.id)!==-1){
  //       showDialog({message:"Project already selected"})
  //     }else{
  //       arr.push({
  //         "id": "",
  //         "unitProjectTypeId": selectProject.id,
  //         "name": selectProject.name,
  //         "endDate": ""
  //       });
  //       $form.projectTypes = arr;
  //       selectProject = null
  //     }
  //   }else{
  //       showDialog({message:"Please Select Project"})
  //   }
  // }

  function addSowOtherType(otherName) {
    if (otherName != undefined) {
      let arr = $form.sows;
      arr.push({
        id: '',
        unitSowId: '',
        name: otherName,
        otherName: otherName,
      });
      $form.sows = arr;
      otherSowName = undefined;
    } else {
      showDialog({ message: 'Please enter engagement service name' });
    }
  }

  function addSowType() {
    let selectSows = sows.filter((item) => item.checked);
    if (selectSows.length > 0) {
      let arr = $form.sows;
      for (let i in selectSows) {
        let selectSow = selectSows[i];
        if (searchKeyByValue(arr, 'unitSowId', selectSow.id) !== -1) {
          return showDialog({
            message: 'Engagement Services already selected',
          });
        }
      }
      for (let i in selectSows) {
        let selectSow = selectSows[i];
        arr.push({
          id: '',
          unitSowId: selectSow.id,
          name: selectSow.name,
          otherName: '',
        });
        $form.sows = arr;
      }
      setTimeout(() => {
        sows = sows.map((item) => {
          item.checked = false;
          return item;
        });
      }, 100);
    } else {
      showDialog({ message: 'Please Select Engagement Services' });
    }
  }

  // function addSowType() {
  //   if(selectSow != null){
  //     let arr = $form.sows;
  //     if(searchKeyByValue(arr,"unitSowId",selectSow.id)!==-1){
  //       showDialog({message:"Sow Type already selected"})
  //     }else{
  //       arr.push({
  //         "id": "",
  //         "unitSowId": selectSow.id,
  //         "name": selectSow.name,
  //         "otherName": ""
  //       });
  //       $form.sows = arr;
  //       selectSow = null
  //     }
  //   }else{
  //       showDialog({message:"Please Select Sow Type"})
  //   }
  // }

  const removeType = (key, type) => {
    if (type == 'sow') {
      let arr = $form.sows;
      arr.splice(key, 1);
      $form.sows = arr;

      let errorArr = $errors.sows;
      errorArr.splice(key, 1);
      $errors.sows = errorArr;
    } else {
      let arr = $form.projectTypes;
      arr.splice(key, 1);
      $form.projectTypes = arr;

      let errorArr = $errors.projectTypes;
      errorArr.splice(key, 1);
      $errors.projectTypes = errorArr;
    }
  };

  const removeProjects = () => {
    if ($form.projectTypes.length != 0) {
      showDialog({
        type: 'confirm',
        title: '',
        message: 'Are you sure ?',
        okFunc: () => {
          $form.projectType = 0;
          $form.projectTypes = [];
        },
        cancelFunc: () => {
          $form.projectType = 1;
          handleChange(customInputEvent(`projectType`, 1));
        },
      });
    } else {
      $form.projectType = 0;
      $form.projectTypes = [];
    }
  };

  const removeSows = () => {
    if ($form.sows.length != 0) {
      showDialog({
        type: 'confirm',
        title: '',
        message: 'Are you sure ?',
        okFunc: () => {
          $form.ongoing = 0;
          $form.sows = [];
        },
        cancelFunc: () => {
          $form.ongoing = 1;
          handleChange(customInputEvent(`ongoing`, 1));
        },
      });
    } else {
      $form.ongoing = 0;
      $form.sows = [];
    }
  };
  let objSelectProject;
  let objSelectSow;
</script>

<div class="p-3 h-100">
  <div class="profile-content mx-auto">
    <div class="block-title mb-4">
      <h3 class="mt-0 title"><span>Engagement Type</span></h3>
    </div>
  </div>
  <div class="Xprofile-content mx-auto h-100 py-1">
    <div class="row">
      <div class="col-md-12">
        <div class="fields-block px-3 pt-3 pb-3 position-relative">
          <div class="row align-items-center project-engagement-block">
            <div class="col-md-3">
              <div class="form-label mb-0 title-block">
                <div class="checkbox c-checkbox">
                  <label>
                    <input
                      type="checkbox"
                      name="projectType"
                      checked={$form.projectType == 1}
                      on:change={(event) => {
                        $form.projectType = event.target.checked ? 1 : 0;
                        if (event.target.checked == false) {
                          removeProjects();
                        }
                      }}
                    />
                    <span class="check-img" />Project</label
                  >
                </div>
              </div>
            </div>
            <div class="col-md-9">
              {#if $form.projectType == 1}
                <div class="d-flex flex-row">
                  <div class="form-group select-block select-client-type engagement-dropdown ms-3">
                    <DropDown
                      checkbox={true}
                      active={true}
                      searchbox={true}
                      title="Select Project"
                      labelFields="name"
                      keyFields="id"
                      option={projectTypes}
                      checkedFields="checked"
                      Style="select-block font-size-13 w-100"
                      on:onSelect={(event) => {
                        addProjectType();
                      }}
                    />
                    <!-- <Select
					bind:this={objSelectProject}
					bind:selectedValue={selectProject}
					containerStyles="min-width:320px"
					items={projectTypes}
				  showChevron={true}
				  isClearable={true}
					getSelectionLabel={(option) => {
					  return option.name;
					}}
					on:select={(ev) => {
					  selectProject=ev.detail
					  addProjectType()
					  setTimeout(()=>{
						selectProject=undefined
						// objSelectProject.select()
						objSelectProject.$$.ctx[3].click()
					  },100)
					}}
					on:clear={(ev) => {
					// selectProject =  null
					}}
					optionIdentifier={"id"}
					getOptionLabel={(option) => {
					  return option.name;
					}}
					placeholder="Select Project"/> -->
                  </div>
                  <!-- <button on:click={()=>addProjectType()}  class="btn btn-link px-0 mb-0 ms-2 border-0 bg-transparent shadow-none">
				  <img class="icon-16" alt="" src="/images/plus.svg" />
				</button> -->
                </div>
              {/if}
            </div>
          </div>
          {#each $form.projectTypes as item, i}
            <div class="d-flex flex-column mb-3 list-items-block">
              <div class="mb-2">{$form.projectTypes[i].name}</div>
              <div
                class="d-flex flex-row align-items-center calendar-content-areaa justify-content-between"
              >
                <div class="date-picker-calendar">
                  <div class="d-flex flex-row">
                    <DatePicker
                      style="active  select-border me-1 calendar-input-block"
                      placeholder="Start Date"
                      on:change={(value) => {
                        $form.projectTypes[i].startDate = value.detail[1];
                        handleChange(
                          customInputEvent(`projectTypes[${i}].startDate`, value.detail[1]),
                        );
                      }}
                      value={$form.projectTypes[i].startDate}
                      error={$errors.projectTypes[i] != undefined
                        ? $errors.projectTypes[i].startDate
                        : undefined}
                      name={`projectTypes[${i}].startDate`}
                    />
                    <DatePicker
                      style="active  select-border me-1 calendar-input-block"
                      placeholder="End Date"
                      on:change={(value) => {
                        $form.projectTypes[i].endDate = value.detail[1];
                        handleChange(
                          customInputEvent(`projectTypes[${i}].endDate`, value.detail[1]),
                        );
                      }}
                      value={$form.projectTypes[i].endDate}
                      error={$errors.projectTypes[i] != undefined
                        ? $errors.projectTypes[i].endDate
                        : undefined}
                      name={`projectTypes[${i}].endDate`}
                    />
                  </div>
                </div>
                <div class="me-0">
                  <button
                    on:click={() => removeType(i, 'project')}
                    class="btn btn-link bg-transparent border-0 shadow-none p-0 ms-1"
                  >
                    <img
                      class="icon-16"
                      alt=""
                      src="/images/remove.svg"
                    />
                  </button>
                </div>
              </div>
            </div>
          {/each}
        </div>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-md-12">
        <div class="fields-block px-3 pt-4 pb-3 position-relative mt-2 mb-2">
          <div class="form-label mb-2 title-block d-flex flex-column justify-content-between">
            <div class="checkbox c-checkbox">
              <label>
                <input
                  type="checkbox"
                  name="ongoing"
                  checked={$form.ongoing == 1}
                  on:change={(event) => {
                    $form.ongoing = event.target.checked ? 1 : 0;
                    if (event.target.checked == false) {
                      removeSows();
                    }
                  }}
                />
                <span class="check-img" />
                Ongoing
              </label>
            </div>
            {#if $form.ongoing == 1}
              <div class="date-picker-calendar mb-3 mt-3">
                <div class="d-flex flex-row">
                  <DatePicker
                    style="active  select-border me-1 calendar-input-block"
                    placeholder="Start Date"
                    on:change={(value) => {
                      $form.ongoingStartDate = value.detail[1];
                      handleChange(customInputEvent(`ongoingStartDate`, value.detail[1]));
                    }}
                    value={$form.ongoingStartDate}
                    error={$errors.ongoingStartDate != undefined
                      ? $errors.ongoingStartDate
                      : undefined}
                    name="ongoingStartDate"
                  />
                  <DatePicker
                    style="active  select-border me-1 calendar-input-block"
                    placeholder="End Date"
                    on:change={(value) => {
                      $form.ongoingEndDate = value.detail[1];
                      handleChange(customInputEvent(`ongoingEndDate`, value.detail[1]));
                    }}
                    value={$form.ongoingEndDate}
                    error={$errors.ongoingEndDate != undefined ? $errors.ongoingEndDate : undefined}
                    name="ongoingEndDate"
                  />
                </div>
              </div>
            {/if}
          </div>
          {#if $form.ongoing == 1}
            <div class="d-flex flex-row mb-4">
              <div class="form-group select-block select-client-type engagement-dropdown">
                <!-- <Select
				bind:selectedValue={selectSow}
				bind:this={objSelectSow}
				containerStyles="min-width:320px"
				items={sows}
				showChevron={true}
				isClearable={true}
				getSelectionLabel={(option) => {
				  return option.name;
				}}
				on:select={(ev) => {
				  selectSow=ev.detail
				  addSowType()
				  setTimeout(()=>{
					selectSow=undefined
					objSelectSow.$$.ctx[3].click()
				  },100)
				}}
				on:clear={(ev) => {
				selectSow =  null
				}}
				optionIdentifier={"id"}
				getOptionLabel={(option) => {
				  return option.name;
				}}
				placeholder="Select Engagement Services"/> -->

                <DropDown
                  checkbox={true}
                  active={true}
                  searchbox={true}
                  title="Select Engagement Services"
                  labelFields="name"
                  keyFields="id"
                  option={sows.filter((item) => {
                    if ($form.clientTypes.length > 0 && item.unitClientTypes.length > 0) {
                      for (var i in item.unitClientTypes) {
                        for (var j in $form.clientTypes) {
                          if ($form.clientTypes[j].unitClientTypeId == item.unitClientTypes[i].id) {
                            return true;
                          }
                        }
                      }
                      return false;
                    }
                    return true;
                  })}
                  checkedFields="checked"
                  Style="select-block font-size-13 w-100"
                  on:onSelect={(event) => {
                    addSowType();
                  }}
                />
              </div>
              <!-- <button on:click={()=>addSowType()} class="btn btn-link px-0 mb-0 ms-2 border-0 bg-transparent shadow-none">
			  <img class="icon-16" alt="" src="/images/plus.svg" />
			</button> -->
            </div>

            <div class="d-flex flex-row mb-2">
              <input
                name="otherName"
                type="text"
                bind:value={otherSowName}
                placeholder="Enter Custom Engagement Services"
                class="form-control"
              />
              <button
                on:click={() => addSowOtherType(otherSowName)}
                class="btn background-blue mb-0 text-white px-4 add-task font-size-12 btn-primary ms-2"
              >
                Add
              </button>
            </div>
          {/if}
          {#each $form.sows as item, i}
            <div
              class="d-flex flex-row align-items-center justify-content-between mb-1 list-items-block"
            >
              <div class=" px-1">
                {$form.sows[i].unitSowId > 0 ? $form.sows[i].name : $form.sows[i].otherName}
              </div>
              <div class="d-flex flex-row align-items-center">
                <div class="me-1">
                  <button
                    on:click={() => removeType(i, 'sow')}
                    class="btn btn-link bg-transparent border-0 shadow-none pe-0"
                  >
                    <img
                      class="icon-16"
                      alt=""
                      src="/images/remove.svg"
                    />
                  </button>
                </div>
              </div>
            </div>
          {/each}
        </div>
      </div>
    </div>
  </div>
</div>
